import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/cssindex'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './permission.js'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import * as componentList from '@/utils/component'


const app = createApp(App)

// 批量注册icon
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 批量注册组件
for (const [key, component] of Object.entries(componentList)) {
    app.component(key, component)
}

app.use(ElementPlus)
app.use(store).use(router).mount('#app')
